export const APP_NAME = "IC FunFlow";
export const APP_TAGLINE = "Animation Management Platform";
